import Scenes from "oc-threejs/Scenes";
import {v3} from "oc-threejs/short3";
import Jaco from "./arrangement/Jaco";
import Jaco3d from "./arrangement3d/Jaco3d";

/**
 * @template {{new (...args: any[]) => {}} Super
 * @param {Super} superClass
 */
export default (superClass=class{}) => class JacoAppMinMix extends superClass {

    /** @type {?Jaco} */
    arrangement = null;
    /** @type {?Jaco3d} */
    arrangement3d = null;
    _currentUpdateId = 0;
    _dirty = false;

    constructor(...args) {
        super(...args);
    }

    dirty() {
        this._dirty = true;
        if (this.ui) {
            this.ui.dirty();
        }
        STAGE.dirty();
    }

    onBeforeRenderStage() {
        if (this._dirty) {
            this._dirty = false;
            this.update3d();
        }
    }

    update3d() {
        if (this.arrangement == null) {
            return;
        }
        const t0 = performance.now();
        this._currentUpdateId++;
        this.arrangement.update3d();
        this._maybeAddArrangement3dToScene();
        this._traverseUpdate3d(this.arrangement3d);
        this._cleanUp();
        this.trigger('afterUpdate3d');
        const t1 = performance.now();
        console.log('APP.update3d()',(t1-t0),'ms');
    }

    /**
     * Ermöglicht es, einen Listener für die Änderung von Werten des Arrangements zu registrieren.
     * Der Vergleich
     * @param getValue ein Callback, das einen Wert des Arrangements zurückgibt. Dieser Wert wird auf Änderung verglichen
     * @param onChange das Callback, das bei einer Veränderung aufgerufen wird
     * @return {onCallback}
     */
    onArrangementChange({getValue, onChange, valueEqualsComparator = (a, b) => a == b}) {
        let oldValue = undefined;

        const onCallback = () => {
            const newValue = getValue();
            if (!valueEqualsComparator(oldValue, newValue)) {
                oldValue = newValue;
                onChange();
            }
        };

        this.on('afterUpdate3d', onCallback);

        // zum eventuellen Abräumen als Referenz zurückgeben
        return onCallback;
    }

    /**
     * @private
     */
    _maybeAddArrangement3dToScene() {
        if (this.arrangement3d !== this.arrangement.jaco3d) {
            Scenes.remove(this.arrangement3d);
            this.arrangement3d = this.arrangement.jaco3d;
            STAGE.scene.add(this.arrangement3d);
        }
    }

    /**
     * @private
     */
    _cleanUp() {
        const toRemove = this._findObjectsToRemove(this.arrangement3d);
        for (let o of toRemove) {
            Scenes.remove(o);
        }
    }

    /**
     * @private
     * @param {THREE.Object3D} object
     * @param {THREE.Object3D[]} [toRemove=[]]
     */
    _findObjectsToRemove(object, toRemove = []) {
        if (object.forbidAutoRemove) {
            return toRemove;
        }
        if (object._updateId !== undefined && object._updateId !== this._currentUpdateId) {
            toRemove.push(object);
            return toRemove;
        }
        for (let o of object.children) {
            this._findObjectsToRemove(o, toRemove);
        }
        return toRemove;
    }

    /**
     * @private
     * @param {THREE.Object3D} object
     */
    _traverseUpdate3d(object) {
        if (object.update3d !== undefined) {
            object.update3d();
        }
        for (let o of object.children) {
            this._traverseUpdate3d(o);
        }
    }

    /**
     * Räumt alle 3D-Objekte ab und baut sie neu auf. Hilfreich, um manche Fehler zu ermitteln.
     * Sollte man allerdings nicht als Teil des normalen Programms verwenden, das wäre echt dirty, bäh!
     */
    clear3dForDebug() {
        Scenes.filter(STAGE.scene, o => o.jaco).forEach(o => o.jaco.clear3dForDebug());
    }

    /**
     * zu implementieren falls JacoCollection implementiert wird.
     * @example
     initApp() {
        this.arrangementType = Commons.slurpDirectory(require.context("./arrangement/", true));
     ...
     jacoFromJson(typename, json) {
        const constructor = this.arrangementType[typename];
         if (constructor){
            return new constructor().fromJSON(json);
        }
        else {
            return super.jacoFromJson(typename, json);
        }
     }
     *
     * @param typename
     * @param json
     */
    jacoFromJson(typename, json) {
        if ("Jaco" == typename) {
            return new Jaco().fromJSON(json);
        }
        throw ('typename not found: ' + typename);
    }
}
